import { useGetExamCourseCommentsQuery } from '@exam-management/graphql';
import { createContext, useMemo } from 'react';

import type { QuestionCommentContextData } from '../../types';

import type { QuestionCommentProviderProps } from './types';

export const QuestionCommentContext = createContext<QuestionCommentContextData>({
  comments: {
    data: [],
    loading: false,
    error: null,
  },
});

export default function QuestionCommentProvider(props: Readonly<QuestionCommentProviderProps>) {
  const { children, taskId, entityId = '', entityType } = props;
  const input = {
    taskId,
    entityId,
    entityType,
  };

  const {
    data,
    loading: isLoading,
    error,
  } = useGetExamCourseCommentsQuery({
    variables: {
      getExamCourseCommentsInput: input,
    },
    skip: !taskId || !entityId || !entityType,
  });

  const contextValue = useMemo(
    () => ({
      comments: {
        data: data?.excGetExamCourseComments.comments ?? [],
        loading: isLoading,
        error: error ?? null,
      },
    }),
    [data],
  );

  return (
    <QuestionCommentContext.Provider value={contextValue}>
      {children}
    </QuestionCommentContext.Provider>
  );
}
